import { render, staticRenderFns } from "./OrgbyReseller.vue?vue&type=template&id=0dcdedb5&scoped=true"
import script from "./OrgbyReseller.vue?vue&type=script&lang=js"
export * from "./OrgbyReseller.vue?vue&type=script&lang=js"
import style0 from "./OrgbyReseller.vue?vue&type=style&index=0&id=0dcdedb5&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dcdedb5",
  null
  
)

export default component.exports